import React from "react";

import styles from "./style.module.scss";

import { useSelectedNode } from "../WithExplainNodeSelection";
import Node from "./Node";

import { AnnotatedPlan, Node as NodeType } from "types/explain";

type Props = {
  plan: AnnotatedPlan;
  databaseId: string;
};

const ExplainNodeTree: React.FunctionComponent<Props> = ({
  plan,
  databaseId,
}) => {
  const root = plan.plan[0].Plan;
  const annotations = plan.annotations;
  const [, setSelectedNode] = useSelectedNode();

  const handleNodeClick = (node: NodeType): void => {
    setSelectedNode(node.extra.id);
  };

  return (
    <div className={styles.explainDetails}>
      <Node
        node={root}
        databaseId={databaseId}
        annotations={annotations}
        onNodeClick={handleNodeClick}
      />
    </div>
  );
};

export default ExplainNodeTree;
